const defaultOgDescription =
  `Meet Mediabook, a modern Computer Science textbook. Mediabook is built with curriculum ` +
  `from Make School&apos;s Bachelor in Applied Computer Science. Welcome to college in the 21st century.`;

const defaultOgImage =
  'https://res.cloudinary.com/makeschool/image/upload/c_fill,g_auto:faces,h_627,w_1200,y_0/v1607092569/MetaImages/hero.jpg';

module.exports = {defaultOgDescription, defaultOgImage};
